import styled from 'styled-components';
export const ColumnTitle = styled.h4 `
  font-size: ${({ theme }) => theme.fontSizes.sizeMd1};
  font-weight: 600;
  line-height: 34px;
`;
//# sourceMappingURL=ColumnTitle.styled.js.map